export default __webpack_public_path__ + "static/media/108.abb1e428.jpg";